import { Button, Text, Title2, makeStyles } from '@fluentui/react-components';
import { tokens } from '@vigeo/ui';
import { LOGIN_URL } from '@/lib/auth';

const useStyles = makeStyles({
  page: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
    maxWidth: '32rem',
    marginInline: 'auto',
    paddingBlock: tokens.spacingVerticalXXXL,
    paddingInline: tokens.spacingHorizontalL,
  },
  actions: {
    display: 'flex',
    gap: tokens.spacingHorizontalM,
  },
});

/**
 * Where office staff land after signing out (#718). It sits outside `/app`, which needs a sign-in,
 * so arriving here does not send anyone straight back in; and outside `/portal`, which is the
 * candidate portal and is closed in the Roster-only production build (#625).
 *
 * Public, and it holds no person data: it is the same page for everybody. Field staff have no
 * account and no sign-in here (CLAUDE.md, "visitor" model); the only thing this page can say to
 * them is to use the link they were sent.
 */
export function SignedOutPage() {
  const styles = useStyles();

  return (
    <main className={styles.page}>
      <Title2 as="h1">You have signed out</Title2>
      <Text>If this is a shared computer, close the browser window as well.</Text>
      <div className={styles.actions}>
        <Button appearance="primary" as="a" href={LOGIN_URL}>
          Sign in again
        </Button>
      </div>
      <Text>Looking for your onboarding? Use the link HR sent you.</Text>
    </main>
  );
}
